import { getApiUrl, getEnvVar } from "@commons-monorepo/index";
import { CalculateCartPayload, ShoppingCart } from "@commons-monorepo/index";
import { camelizeKeys, decamelizeKeys } from "humps";

export const calculateCart = async (payload: CalculateCartPayload) => {
  return fetch(`${getApiUrl()}/api/ms/calculator/shopping-cart`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
      "api-key-sumer": getEnvVar("PUBLIC_API_KEY"),
    } as { [key: string]: string },
    body: JSON.stringify(decamelizeKeys(payload)),
  }).then(async (res) => {
    return camelizeKeys(await res.json()) as ShoppingCart;
  });
};

export const getCrossSelling = async (payload: CalculateCartPayload) => {
  return fetch(`${getApiUrl()}/api/ms/orchestrator/shopping-cart/recommended`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
      "api-key-sumer": getEnvVar("PUBLIC_API_KEY"),
    } as { [key: string]: string },
    body: JSON.stringify(payload),
  });
};
